/**
 * 地图调度模块
 * 2018-1-24
 */
"use strict";
angular.module("mapSchedulingModule", [    
    "mapSchedulingManageModule", //地图调度管理
    "mapSchedulingAddEditModule" //地图调度 添加/编辑
]);